(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/models/draws.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/models/draws.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.models.Draws = Backbone.Model.extend({
    initialize: function() {
      var self = this;
      svs.tt.app.radio.on('filtersApplied', function(filters) {
        self.set('filters', filters, { silent: true });
        self.trigger('change');
      });
    },

    defaults: function() {
      this.set('draws', []);
      this.set('filters', {});
    },

    url: function() {
      var setting = this.get('productSetting');
      var url;

      if (svs.utils.products.helpers.isTopptipset(setting.productType)) {
        url = svs.core.jupiter.url() + '/draw/1/topptipsetfamily/draws';
      } else {
        url =
          svs.core.jupiter.url() +
          '/' +
          'search/1/query/?ctx=draw&type=' +
          setting.productType +
          '&rangefilter=payload.draw.regCloseTime;gt;now-1d' +
          '&offset=' +
          setting.offset +
          '&count=' +
          setting.count;

        if (setting.productType === 'oddsetlist') {
          url += '&sort=payload.draw.regCloseTime';
        }
      }

      return url;
    },

    parse: function(response) {
      if (response.totalCount > this.get('productSetting').count) {
        this.get('productSetting').offset = this.get('productSetting').count;
        this.get('productSetting').count += 100;
        this.fetch();
      }
      if (response.draws) {
        response.draws = this.get('draws').concat(response.draws);
      } else if (response.result) {
        response.draws = [];

        _.each(response.result, function(item) {
          response.draws.push(item.payload.draw);
        });

        response.draws = this.get('draws').concat(response.draws);
      }

      var availableSports = [];

      response.draws.forEach(function(draw) {
        if (svs.utils.products.helpers.isOddset(draw.productId)) {
          if (draw.match) {
            availableSports.push(draw.sport);
          }
        } else if (draw.drawEvents) {
          draw.drawEvents.forEach(function(event) {
            if (event.match && event.match.sport) {
              availableSports.push(event.match.sport);
            }
          });
        } else {
          availableSports.push(draw.sport);
        }

        var isTopptipset = svs.utils.products.helpers.isTopptipset(draw.productFamily);
        var isPowerplay = svs.utils.products.helpers.isPowerplay(draw.productName);
        var isFulltraff = svs.utils.products.helpers.isFulltraff(draw.productName);

        if (!isTopptipset && !isPowerplay && !isFulltraff) {
          return;
        }

        if (isTopptipset) {
          var isStryk = svs.utils.products.helpers.isTopptipsetStryk(draw.productName);
          var isExtra = svs.utils.products.helpers.isTopptipsetExtra(draw.productName);
          draw.copyValue = 'Topptipset';

          if (isStryk) {
            draw.copyValue += ',Stryk';
          }

          if (isExtra) {
            draw.copyValue += ',Europa';
          }

          draw.copyValue += ',Omg=' + draw.drawNumber + ',Insats=1';
        }

        if (isPowerplay) {
          draw.copyValue = 'Powerplay,Omg=' + draw.drawNumber + ',Insats=1';
        }

        if (isFulltraff) {
          draw.copyValue = 'Fulltraff,Omg=' + draw.drawNumber;
        }
      });

      if (availableSports.length > 0) {
        availableSports = _.uniq(availableSports, false, function(item) {
          return item.type;
        });
      }

      svs.tt.app.radio.trigger('availableSportsUpdated', availableSports);

      return response;
    },

    newProductSelected: function(productSetting) {
      this.set('draws', []);
      this.set('productSetting', productSetting);
    },

    filtersApplied: function(filters) {
      svs.tt.logger.log('filtersApplied');
      this.set('filters', filters);
    }
  });
})(Backbone, _, svs);


 })(window);